const MASS_PRODUCTION_SIMULATION_RESULT = {
  MASS_PRODUCTION_COURSE_IS_CHEAPER: "1",
  MASS_PRODUCTION_COURSE_IS_CHEAPER_IF_REPEAT: "2",
  NORMAL_COURSE_IS_CHEAPER: "3",
} as const

export default MASS_PRODUCTION_SIMULATION_RESULT
